<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-16 09:39:27
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-16 11:07:10
 * @name: 支付确认
 * @Description: 支付确认
 * @FilePath: \preSaleNafterSaleInside\project\src\views\index\payConfirm\payConfirmRouter.vue
 * @Author: desktop
-->
<template>
  <div>

  </div>
</template>
<script>
export default {
  name: 'indexPayConfirm',  
}
</script>
<style lang="scss" scoped>

</style>